import { forEach } from 'lodash'
import jsonApiNormalize from '@base/json-api-normalizer.js'
import { receiveEntities } from '@actions/entity_actions.js'
import { toastSuccess } from '@actions/toast_actions.js'
import { initializeView, saveOptionsComplete } from '../view_options_slice.js'

export const handleSaveOptionsSuccess = res => {
  return dispatch => {
    const parsedJSON = res.data
    const normalized = jsonApiNormalize(parsedJSON, { camelizeKeys: false, camelizeTypeValues: false })

    // Re-initialize the views using updated effective options
    forEach(normalized.views, view => {
      const viewId = view.id
      const effectiveOptions = view?.attributes?.effective_options
      dispatch(initializeView({ viewId, options: effectiveOptions }))
      dispatch(saveOptionsComplete({ viewId, options: effectiveOptions }))
      dispatch(toastSuccess('Saved view'))
    })
    // Update the entities with the normalized data
    dispatch(receiveEntities(normalized))
  }
}
